// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_PegapermissoesusuarioResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for /usuarios/pegaPermissoesUsuario
 *
 * Returns user permissions including the user's identity, their Cognito
 * groups, and their franchise permission set.
 */
import type { Usuarios_PegausuariosRow } from './Usuarios_PegausuariosRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Usuarios_PegapermissoesusuarioResponseDados {
Usuario: Usuarios_PegausuariosRow
Groups: string[]
Franquias: object
}

export type Usuarios_PegapermissoesusuarioResponse = ApiResponse<Usuarios_PegapermissoesusuarioResponseDados>;

registerResponseContract('Usuarios_PegapermissoesusuarioResponse', {
  Usuario: {
    type: 'object',
    required: false,
    fields: {
      sub:               { type: 'string',  required: true },
      username:          { type: 'string',  required: true },
      name:              { type: 'string',  required: false },
      email:             { type: 'string',  required: false },
      enabled:           { type: 'boolean', required: false },
      status:            { type: 'string',  required: false },
      phone_number:      { type: 'string',  required: false },
      bgcolor:           { type: 'string',  required: false },
      picture:           { type: 'string',  required: false },
      address:           { type: 'string',  required: false },
      documento:         { type: 'string',  required: false },
      origem:            { type: 'string',  required: false },
      created_at:        { type: 'string',  required: false },
      updated_at:        { type: 'string',  required: false },
      versaoSistema:     { type: 'string',  required: false },
      language:          { type: 'string',  required: false },
      mcp_scopes:        { type: 'string',  required: false },
      dw_scopes:         { type: 'string',  required: false },
      franquias_cognito: { type: 'string',  required: false },
      groups:            { type: 'array',   required: false },
      franquias:         { type: 'array',   required: false },
    },
  },
  Groups:    { type: 'array',   required: true },
  Franquias: { type: 'object',  required: false },
})
